import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * `/client-secrets` lists the clients and `/client-secrets/:clientSlug` opens
 * one of them. Both are served by the same page extension, so the route ref
 * covers the parameterless root — the slug is read with `useParams`.
 */
export const rootRouteRef = createRouteRef();
